import axios from 'axios';

import BaseService from "./BaseService";
import LogUtils from "../utils/LogUtils";
import settings from "../settings/settings";

class VectorFocusService extends BaseService {

  constructor() {
    super();
    this.TAG = "VectorFocusService";

    this.logUtils = new LogUtils();
  }

  async getUserVectorFocus(userId) {
    let vectorFoci = {};

    try {
      const response = this.getResponse(await axios(this.getBasicHttpRequest(
        this.HTTP_METHODS.GET,
        `${settings.MANAGEMENT_SERVICE_URL}/vector-focus/user/${userId}`,
        this.getDefaultHeaders(true)
      )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: "Não foi possível retornar os focos."
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Não foi possível retornar os focos."
        };
      }

      vectorFoci = response.data;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to getUserVectorFocus", err);

      return {
        status: -2,
        msg: "Não foi possível retornar os focos"
      };
    }

    return {
      status: 1,
      msg: "Os focos foram retornados com sucesso.",
      data: vectorFoci
    };
  }

  async getCityVectorFocus(cityId) {
    let vectorFoci = {};

    try {
      const response = this.getResponse(await axios(this.getBasicHttpRequest(
        this.HTTP_METHODS.GET,
        `${settings.MANAGEMENT_SERVICE_URL}/vector-focus/city/${cityId}`,
        this.getDefaultHeaders(true)
      )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: "Não foi possível retornar os focos da cidade."
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Não foi possível retornar os focos da cidade."
        };
      }

      vectorFoci = response.data;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to getCityVectorFocus", err);

      return {
        status: -2,
        msg: "Não foi possível retornar os focos da cidade"
      };
    }

    return {
      status: 1,
      msg: "Os focos da cidade foram retornados com sucesso.",
      data: vectorFoci
    };
  }

  async getCityVectorFocusListWithFilters({ cityId, filters }) {
    let cityVectorFocusList = null;

    try {
      if (!cityId) {
        return this.buildResult(0, 'Não foi possível retornar a lista de focos de vetores da cidade');
      }

      const response = this.getResponse(await axios(
        this.getBasicHttpRequest(
          this.HTTP_METHODS.POST,
          `${settings.MANAGEMENT_SERVICE_URL}/get-filtered-city-vector-focus`,
          this.getDefaultHeaders(true, true),
          {
            "cityId": cityId,
            "filters": filters
          },
          true
        )));

      if (response.status !== 1) {
        return {
          status: -1,
          msg: 'Não foi possível retornar a lista de focos de vetores da cidade'
        };
      }

      if (!response.data) {
        return {
          status: -2,
          msg: 'Não foi possível retornar a lista de focos de vetores da cidade'
        };
      }

      cityVectorFocusList = response.data;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to getUserVectorFocusList", err);
      return {
        status: -3,
        msg: 'Não foi possível retornar a lista de focos de vetores da cidade'
      };
    }

    return {
      status: 1,
      msg: "Os focos da cidade foram retornados com sucesso.",
      data: cityVectorFocusList
    };
  }

  async getVectorFocus(vectorFocusId) {
    let vectorFocus = {};

    try {
      const response = this.getResponse(await axios(this.getBasicHttpRequest(
        this.HTTP_METHODS.GET,
        `${settings.MANAGEMENT_SERVICE_URL}/vector-focus/${vectorFocusId}`,
        this.getDefaultHeaders(true)
      )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: "Não foi possível retornar o foco."
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Não foi possível retornar o foco."
        };
      }

      vectorFocus = response.data;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to getVectorFocus", err);

      return {
        status: -2,
        msg: "Não foi possível retornar o foco"
      };
    }

    return {
      status: 1,
      msg: "O foco foi retornado com sucesso.",
      data: vectorFocus
    };
  }

  async createVectorFocus({ userId, cityId, denounceStatusId, geoLocationId, pictureId,
    description, diseaseVectorId, possibleFocusId }) {
    let newVectorFocus = null;

    try {
      const response = this.getResponse(await axios(
        this.getBasicHttpRequest(this.HTTP_METHODS.POST,
          `${settings.MANAGEMENT_SERVICE_URL}/vector-focus`,
          this.getDefaultHeaders(true, true),
          {
            userId: userId,
            cityId: cityId,
            denounceStatusId: denounceStatusId,
            geoLocationId: geoLocationId,
            pictureId: pictureId,
            description: description,
            diseaseVectorId: diseaseVectorId,
            possibleFocusId: possibleFocusId,
            addressId: null,
            isAnonymous: false,
            seriousnessScore: 0.5
          },
          true
        )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: response.error ? response.error : "Não foi possível criar o novo foco."
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Houve um erro ao processar a operação."
        };
      }

      newVectorFocus = response.data;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to createVectorFocus", err);

      return {
        status: -2,
        msg: "Não foi possível criar o novo foco"
      };
    }

    return {
      status: 1,
      msg: "O novo foco foi criado com sucesso.",
      data: newVectorFocus
    };
  }

  async updateVectorFocus({ addressId, vectorFocusId, diseaseVectorId, denounceStatusId, description,
    pictureId, possibleFocusId }) {
    try {
      const response = this.getResponse(await axios(
        this.getBasicHttpRequest(this.HTTP_METHODS.PUT,
          `${settings.MANAGEMENT_SERVICE_URL}/vector-focus`,
          this.getDefaultHeaders(true),
          {
            addressId,
            vectorFocusId,
            diseaseVectorId,
            denounceStatusId,
            description,
            pictureId,
            seriousnessScore: 0.5,
            possibleFocusId
          }
        )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: response.error ? response.error : "Não foi possível atualizar o foco do vetor."
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Houve um erro ao processar a operação."
        };
      }

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to updateVectorFocus", err);

      return {
        status: -2,
        msg: "Não foi possível atualizar o foco do vetor"
      };
    }

    return {
      status: 1,
      msg: "O foco do vetor foi atualizado com sucesso."
    };
  }

  async deleteVectorFocus({ vectorFocusId }) {
    try {
      const response = this.getResponse(await axios(
        this.getBasicHttpRequest(this.HTTP_METHODS.DELETE,
          `${settings.MANAGEMENT_SERVICE_URL}/vector-focus/`,
          this.getDefaultHeaders(true),
          {
            vectorFocusId: vectorFocusId
          }
        )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: response.error ? response.error : "Não foi possível deletar o foco."
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Houve um erro ao processar a operação."
        };
      }

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to deleteVectorFocus", err);

      return {
        status: -2,
        msg: "Não foi possível deletar o foco."
      };
    }

    return {
      status: 1,
      msg: "Foco deletado com sucesso."
    };
  }

}

export default VectorFocusService;